import React from 'react'
import { useState, useEffect, useRef } from 'react';
import { initApp } from './game_files/App.js';
import PuzzleCommands from './PuzzleCommands.jsx';
import BottomChrome from './BottomChrome.jsx';
import PuzzleStorage from './PuzzleStorage.js';
import useMediaQuery from './MediaQuery.js';

function Puzzles({ currentPuzzleName, setCurrentPuzzleName }) {
  const [ reset, incrementReset ] = useState(0);
  const sceneRef = useRef(null);
  const saved = localStorage.getItem("puzzles");
  const puzzles = JSON.parse(saved);
  const current = puzzles[currentPuzzleName];
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    let isMounted = true;
    const scene = initApp(current.dimensions.x, current.dimensions.y, current.dimensions.z, currentPuzzleName, PuzzleStorage);
    sceneRef.current = scene;

    scene.Load().then(() => {
      if (isMounted) {
        scene.Begin();

        const leftNav = document.getElementById('nav-container');
        const rightNav = document.getElementById('puzzleNav');
        console.log(leftNav?.offsetWidth, rightNav?.offsetWidth, 'test');

        const navObserver = new ResizeObserver(() => {
          const leftWidth = leftNav?.offsetWidth ?? 0;
          const rightWidth = rightNav?.offsetWidth ?? 0;
          if (leftWidth > 0 || rightWidth > 0) {
            sceneRef.current?.recalculateProjection();
            navObserver.disconnect();
          }
        });

        if (leftNav) navObserver.observe(leftNav);
        if (rightNav) navObserver.observe(rightNav);

        const canvas = document.getElementById('game-surface');
        const canvasObserver = new ResizeObserver(() => {
          sceneRef.current?.recalculateProjection();
        });
        canvasObserver.observe(canvas);
      }
    });

    return () => {
      isMounted = false;
      scene?.Unload();
      sceneRef.current = null;
    };
  }, [currentPuzzleName, reset]);
  /*
  useEffect(() => {
    let isMounted = true;


    const scene = initApp(current.dimensions.x, current.dimensions.y, current.dimensions.z, currentPuzzleName, PuzzleStorage);
    sceneRef.current = scene;

    scene.Load().then(() => {
      if (isMounted) {
        scene.Begin();
      }
    });

    return () => {
      isMounted = false;
      scene?.Unload();
      sceneRef.current = null;
    }
  }, [currentPuzzleName, reset]
  );
  */

  const savePosition = () => {
    sceneRef.current?.SavePosition(); // now this is accessible
  };
  
  const loadPosition = () => {
    sceneRef.current?.LoadPosition();
  }

  const shuffle = () => {
    sceneRef.current?.Shuffle();
  }

//quick fix for canvas
  return (
    <div className='puzzleBox'>
      {!isMobile && (
        <div id='puzzle-title' className='puzzle-title'>
          <span>{currentPuzzleName}</span>
        </div>
      )}
      <canvas className='game-surface' id="game-surface" width={5000} height={4000} background-color='black'>
        Your browser does not support html5
      </canvas>
      {isMobile ? (
        <BottomChrome
          currentPuzzleName={currentPuzzleName}
          setCurrentPuzzleName={setCurrentPuzzleName}
          onShuffle={shuffle}
          onLoad={loadPosition}
          onSave={savePosition}
          triggerReset={() => incrementReset(n => n + 1)}
          dimensions={current.dimensions}
        />
      ) : (
        <PuzzleCommands
          onShuffle={shuffle}
          onLoad={loadPosition}
          onSave={savePosition}
          puzzleName={currentPuzzleName}
          triggerReset={() => incrementReset(n => n + 1)}
          dimensions={current.dimensions}
        />
      )}
    </div>
  )
}

export default Puzzles
